import { useState, useEffect } from 'react'

export default function CountdownTimer() {
  const [countdown, setCountdown] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  })

  useEffect(() => {
    const calculateCountdown = () => {
      // Event date: 29 November 2025
      const eventDate = new Date('2025-11-29T00:00:00').getTime()
      const now = new Date().getTime()
      const distance = eventDate - now

      if (distance > 0) {
        setCountdown({
          days: Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((distance % (1000 * 60)) / 1000),
        })
      }
    }

    calculateCountdown()
    const timer = setInterval(calculateCountdown, 1000)

    return () => clearInterval(timer)
  }, [])

  return (
    <div className="flex flex-col items-center gap-6">
      <div className="text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-kala-primary mb-2">Event Starts In</h2>
      </div>
      <div className="countdown-container">
        <div className="countdown-box">
          <div className="countdown-value">{String(countdown.days).padStart(2, '0')}</div>
          <div className="countdown-label">DAYS</div>
        </div>
        <div className="countdown-box">
          <div className="countdown-value">{String(countdown.hours).padStart(2, '0')}</div>
          <div className="countdown-label">HOURS</div>
        </div>
        <div className="countdown-box">
          <div className="countdown-value">{String(countdown.minutes).padStart(2, '0')}</div>
          <div className="countdown-label">MINUTES</div>
        </div>
        <div className="countdown-box">
          <div className="countdown-value">{String(countdown.seconds).padStart(2, '0')}</div>
          <div className="countdown-label">SECONDS</div>
        </div>
      </div>
    </div>
  )
}
